import * as React from 'react';
import { StandardVisitorAgreementContentUI } from './content/StandardVisitorAgreementUI';
import { HertzVisitorAgreementContentUI } from './content/HertzVisitorAgreementUI';

// NOTE: In future this could be exported from this component if it is needed elsewhere
const HERTZ_TEMPLATE_NAME = 'hertz';

export interface IVisitorAgreementUIStateProps {
    templateName: string;
    dealerName: string;
}
export interface IVisitorAgreementUIDispatchProps {
}

export type IVisitorAgreementUIProps = IVisitorAgreementUIStateProps & IVisitorAgreementUIDispatchProps;

const VisitorAgreementUI: React.ComponentType<IVisitorAgreementUIProps> = (props: IVisitorAgreementUIProps) => {
    let VisitorAgreementContentUI;

    switch (props.templateName) {
        case HERTZ_TEMPLATE_NAME:
            VisitorAgreementContentUI = HertzVisitorAgreementContentUI;
            break;

        default:
            VisitorAgreementContentUI = StandardVisitorAgreementContentUI;
            break;
    }
    return (
        <div className="Disclaimer-container">
            <VisitorAgreementContentUI dealerName={props.dealerName} />
        </div>
    );
};

export default VisitorAgreementUI;
